module.exports = __webpack_public_path__ + "static/media/图片_11.49fd1eb1.jpg";